import { useEffect, useState } from 'react'
import { useSearch } from '@tanstack/react-location'
// Store
import { useStore } from 'TourApp/store'
import IntroContent from './components/IntroContent'
import IntroCodeEntry from './components/IntroCodeEntry'
// Images
import logo from 'shared/assets/images/sparx-logo.png'
import { getCdnAssetUrl } from 'shared/helpers/assets'

export default function IntroScreen() {
  const { toggleSidebar, wipeTourData, tourData } = useStore()
  const [tourCode, setTourCode] = useState(null)

  const { tour } = useSearch()

  useEffect(() => {
    toggleSidebar(false)
    wipeTourData()
  }, [toggleSidebar, wipeTourData])

  useEffect(() => {
    const tourCode = tour ? String(tour) : null
    setTourCode(
      process.env.NODE_ENV === 'development'
        ? tourCode || localStorage.getItem('devTourCode') || 'BA71CB23-A86D-43D3-AD01-56CAF79D2714'
        : tourCode,
    )
  }, [tour])

  function getPropertyImage(tourData) {
    return getCdnAssetUrl(tourData.units[0].unit.unit_type.property.property_landscape_image)
  }

  return (
    <div className="h-screen w-screen overflow-scroll" id="intro">
      <div
        className={`backdrop-opacity-5 flex flex-col relative ${
          tourCode ? 'justify-end' : 'justify-end lg:justify-center items-center'
        } ${!tourData ? 'h-full' : 'h-auto'} lg:h-full w-full`}
      >
        {tourData && (
          <>
            <div
              className={`h-full w-full static lg:absolute top-0 left-0 object-cover z-10 ${
                tourCode ? 'lg:w-[70%] lg:h-auto lg:top-[65px] lg:right-[75px] lg:left-auto' : ''
              }`}
            >
              {!getPropertyImage(tourData) && (
                <video autoPlay loop muted playsInline poster="/content/videos/cover.png">
                  <source src="/content/videos/bg2.mp4" type="video/mp4" />
                </video>
              )}
              {getPropertyImage(tourData) && <img src={getPropertyImage(tourData)} />}
            </div>

            <div
              className={`absolute top-0 left-0 lg:left-[75px] w-full justify-center lg:justify-start mt-[50px] lg:mt-[65px] flex z-30 ${
                !tourCode ? 'lg:hidden' : ''
              }`}
            >
              <img src={logo} className="h-[30px] lg:h-[20px]" alt="sparx-logo" />
            </div>
            {!getPropertyImage(tourData) && (
              <div className="bg-white h-full w-full opacity-30 absolute left-0 top-0 z-20" />
            )}
          </>
        )}
        <div className="relative z-30">
          {tourCode && <IntroContent tourCode={tourCode} />}
          {!tourCode && <IntroCodeEntry onSubmit={setTourCode} />}
        </div>
      </div>
    </div>
  )
}
